if (!customElements.get('subscription-popup')) {
  // KAF custom (23 Oct 2026), see ~/Work/KAF/Shopify/popup-delay/README.md
  // - opens N seconds (data-delay, default 90) after the visit started, on any page
  // - once closed (X, overlay, Esc or a click on its button/link) it stays closed for the rest of the visit
  // - a visit ends after 30 min without activity; the next visit shows it again
  const KAF_VISIT_KEY = 'kaf:popup-visit';
  const KAF_VISIT_TIMEOUT = 30 * 60 * 1000;

  const readVisit = () => {
    try {
      const v = JSON.parse(window.localStorage.getItem(KAF_VISIT_KEY));
      if (v && typeof v.start === 'number' && Date.now() - v.last < KAF_VISIT_TIMEOUT) return v;
    } catch (e) {}
    return null;
  };

  const writeVisit = (v) => {
    v.last = Date.now();
    try {
      window.localStorage.setItem(KAF_VISIT_KEY, JSON.stringify(v));
    } catch (e) {}
    return v;
  };

  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.delayMs = (parseInt(this.dataset.delay, 10) || 90) * 1000;

        if (!Shopify.designMode) {
          // Count this page view as activity and keep the visit alive while the tab is in use.
          writeVisit(readVisit() || { start: Date.now(), dismissed: false });
          this.keepAlive = setInterval(() => {
            if (document.visibilityState !== 'visible') return;
            const v = readVisit();
            if (v) writeVisit(v);
          }, 60 * 1000);

          // A click on the popup's button/link also counts as closing it.
          this.addEventListener('click', (event) => {
            if (event.target.closest('a[href]')) this.markDismissed();
          });
        }

        window.FoxTheme.DOMready(this.handleOpen.bind(this));
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        clearInterval(this.keepAlive);
      }

      markDismissed() {
        if (Shopify.designMode) return;
        const v = readVisit() || { start: Date.now() };
        v.dismissed = true;
        writeVisit(v);
      }

      prepareToHide() {
        super.prepareToHide();
        this.markDismissed();
      }

      canShow() {
        const v = readVisit();
        return !(v && v.dismissed);
      }

      showIfAllowed() {
        if (this.canShow()) this.show();
      }

      handleOpen() {
        if (Shopify.designMode) return;
        if (!this.canShow()) return false;

        switch (this.triggerOpen) {
          case 'delay': {
            const v = readVisit();
            const start = v ? v.start : Date.now();
            const wait = Math.max(0, start + this.delayMs - Date.now());
            setTimeout(() => this.showIfAllowed(), wait);
            break;
          }
          case 'scroll_down':
            this.triggerAfterScroll(700, this.showIfAllowed.bind(this));
            break;
          default:
            this.showIfAllowed();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }
    }
  );
}
